import { autoserialize, autoserializeAs } from 'cerialize';
import BaseEntity from '../BaseEntity';
import TableColumn from "../TableColumn";
import { getVm } from "@/util/GlobalVm";

export default class TUKMasterExpense extends BaseEntity {

    @autoserialize
    public nama: string = '';

    @autoserialize
    public kode: string = '';

    @autoserialize
    public keterangan: string = '';

    @autoserializeAs(Boolean)
    public is_active: boolean = true;

    public table(): any {
        return {
            nama: this.nama,
            kode: this.kode,
            keterangan: this.keterangan,
            is_active: this.is_active
        };
    }

    public static columnName(): Array<any> {
        const config = new TUKMasterExpense().table();
        let keys = Object.keys(config);

        return keys.map((field: any) => {
            const tableColumn = new TableColumn();
            tableColumn.name = getVm().$t(`label.${field}`);
            if (field === 'is_active' || field === 'kode') {
                tableColumn.position = 'centered';
            }
            return tableColumn;
        });
    }
}
